import { render, staticRenderFns } from "./BackToAppointmentBtn.vue?vue&type=template&id=645fb62f&scoped=true&"
import script from "./BackToAppointmentBtn.vue?vue&type=script&lang=js&"
export * from "./BackToAppointmentBtn.vue?vue&type=script&lang=js&"
import style0 from "./BackToAppointmentBtn.vue?vue&type=style&index=0&id=645fb62f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645fb62f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAvatar,VChip,VIcon,VScaleTransition})
